<template>
  <div>
    <div
      class="kejuruteraan-awam-menu"
      :class="{ open: isKejuruteraanAwamMenuOpen }"
    >
      <ul>
        <li>
          <RouterLink to="/kejuruteraan-awam">
            OKU
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-awam/spah">
            SPAH
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-awam/cerun">
            Cerun
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-awam/jalan">
            Jalan
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kejuruteraan-awam/cctv">
            CCTV
          </RouterLink>
        </li>
      </ul>
    </div>
    <div
      v-if="isKejuruteraanAwamMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isKejuruteraanAwamMenuOpen"
      class="kejuruteraan-awam-toggle-button"
      @click="toggleKejuruteraanAwamMenu"
    >
      <span class="vertical-text">KEJURUTERAAN AWAM</span>
    </button>
  </div>
</template>


<script setup>
import { ref } from 'vue'

const isKejuruteraanAwamMenuOpen = ref(false)

const toggleKejuruteraanAwamMenu = () => {
  isKejuruteraanAwamMenuOpen.value = !isKejuruteraanAwamMenuOpen.value
  if (isKejuruteraanAwamMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isKejuruteraanAwamMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-kejuruteraan-awam-menu', () => {
  isKejuruteraanAwamMenuOpen.value = false
})
</script>

<style scoped>
/* Kejuruteraan Awam Menu */
.kejuruteraan-awam-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.kejuruteraan-awam-menu.open {
  transform: translateX(0);
}

.kejuruteraan-awam-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.kejuruteraan-awam-menu li {
  margin-bottom: 10px;
}

.kejuruteraan-awam-menu a,
.kejuruteraan-awam-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Kejuruteraan Awam Toggle Button */
.kejuruteraan-awam-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.kejuruteraan-awam-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
